module.exports = __webpack_public_path__ + "img/Group 3188 (1).e28c2c88.png";